// src/Tiptap.tsx
import React from "react";

import ReactQuill, { Quill } from "react-quill-new";
import PropTypes from "prop-types";
import { httpClient } from "../../utils/HttpClient";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { useAuth } from "../../Context/AuthContext";
import ImageUploader from "quill-image-uploader";
import ImageBlot from "quill/formats/image";
import { useRef } from "react";
import "react-quill-new/dist/quill.snow.css";
import { useCallback } from "react";

Quill.register("modules/imageUploader", ImageUploader);
Quill.register({ "formats/imageBlot": ImageBlot });
//import PropTypes from "prop-types";

const EmailTextBox = ({ name, defaultValue, changeHandler }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const reactQuillRef = useRef();
  // Render the Slate context.

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      if (input !== null && input.files !== null) {
        const file = input.files[0];
        const formData = new FormData();
        formData.append("image", file);
        httpClient(
          "POST",
          ApiEndpoint + "files/uploadfile",
          formData,
          userData.token
        ).then((res) => {
          const url = res.data.url;

          const quill = reactQuillRef.current;
          if (quill) {
            const range = quill.getEditorSelection();
            range && quill.getEditor().insertEmbed(range.index, "image", url);
          }
        });
      }
    };
  }, []);
  return (
    <div style={{ height: "400px" }}>
      <ReactQuill
        style={{ height: "300px" }}
        theme="snow"
        ref={reactQuillRef}
        modules={{
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ["bold", "italic", "underline", "strike", "blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link", "image"],
            ],
            handlers: { image: imageHandler },
          },
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "list",
          "indent",
          "link",
          "image",
          "imageBlot", // #5 Optinal if using custom formats
        ]}
        value={defaultValue}
        name={name}
        onChange={(event) => {
          changeHandler({ target: { name: name, value: event } });
        }}
      />
    </div>
  );
};
EmailTextBox.propTypes = {
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  changeHandler: PropTypes.func,
};
export default EmailTextBox;
